import React, { useState } from "react";

const FAQSection = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const FAQs = [
        {
            question: "What is Doctors' Jobs and How Can It Help My Job Search?",
            answer: [
                "Doctors' Jobs is an all-in-one job search platform designed exclusively for doctors. Whether you're applying for MO posts, exploring healthtech, or transitioning into consulting, our tools simplify and personalise your job search.",
            ],
        },
        {
            question: "What Types of Medical Jobs Are Listed?",
            answer: [
                "We list a wide range of clinical, academic, and non-traditional jobs for doctors. These include specialist placements, public health, telemedicine, medical education, research, and startups, updated every two weeks.",
            ],
        },
        {
            question: "How Does the CV Analyser Work?",
            answer: [
                "Upload your CV and choose your target field. Our AI reviews structure, relevance, and clarity using role-specific best practices, then provides targeted recommendations to help you stand out.",
            ],
        },
        {
            question: "Can I Save and Track Jobs I'm Interested In?",
            answer: [
                "Yes. Bookmark jobs you like, track each step of your applications, and manage it all from your personalised dashboard. Just create a free account to get started.",
            ],
        },
        {
            question: "Is There a Cost to Use Doctors' Jobs?",
            answer: [
                "Browsing and using the job tracker is completely free. You'll also receive one free CV analysis credit when you sign up. Additional credits can be purchased as needed.",
            ],
        },
    ];

    return (
        <section id="faq" className="bg-white py-12">
            <div className="container mx-auto px-4 sm:px-6 lg:px-12">
                <div className="flex flex-col sm:flex-col md:flex-row">
                    <div className="md:w-1/3 mb-8 md:mb-0">
                        <h2 className="text-[24px] md:text-4xl font-bold mb-4 text-[#333333]">Frequently asked questions</h2>
                    </div>

                    <div className="space-y-4 md:w-2/3">
                        {FAQs.map((faq, index) => (
                            <div
                                key={index}
                                className="border-b border-gray-200 overflow-hidden"
                            >
                                <button
                                    className="w-full text-left py-4 text-lg font-medium text-black flex justify-between items-center focus:outline-none"
                                    onClick={() => toggleAccordion(index)}
                                >
                                    {faq.question}
                                    <span className="ml-2">
                                        {openIndex === index ? (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5 text-black"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M5 10a1 1 0 011.707-.707L10 12.586l3.293-3.293A1 1 0 0114.707 10l-4 4a1 1 0 01-1.414 0l-4-4A1 1 0 015 10z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        ) : (
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5 text-black"
                                                viewBox="0 0 20 20"
                                                fill="currentColor"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M7 10a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1z"
                                                    clipRule="evenodd"
                                                />
                                                <path
                                                    fillRule="evenodd"
                                                    d="M10 3a1 1 0 011 1v4a1 1 0 11-2 0V4a1 1 0 011-1z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        )}
                                    </span>
                                </button>
                                {openIndex === index && (
                                    <div className="pb-4 text-gray-700">
                                        {faq.answer.map((paragraph, i) => (
                                            <p key={i} className="mb-2">
                                                {paragraph}
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
